export const setPressReleases = (state, pressReleases) => {
  state.pressReleases = pressReleases
}
